import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

export const TRN_PERMISSIONS_FETCH = 'TRN_PERMISSIONS_FETCH'
export const TRN_PERMISSIONS_FETCH_CANCELED = 'TRN_PERMISSIONS_FETCH_CANCELED'
export const TRN_PERMISSIONS_FETCH_ERROR = 'TRN_PERMISSIONS_FETCH_ERROR'
export const TRN_PERMISSIONS_FETCH_FULFILLED = 'TRN_PERMISSIONS_FETCH_FULFILLED'

export const permissionsFetch = (payload) => ({
  payload,
  type: TRN_PERMISSIONS_FETCH,
})

export const permissionsFetchFulfilled = (payload) => ({
  payload,
  type: TRN_PERMISSIONS_FETCH_FULFILLED,
})

export const permissionsFetchCanceled = () => ({
  payload: null,
  type: TRN_PERMISSIONS_FETCH_CANCELED,
})

export const permissionsFetchError = (payload) => ({
  payload,
  type: TRN_PERMISSIONS_FETCH_ERROR,
})

export const permissionsFetchEpic = (action$) =>
  action$.pipe(
    ofType(TRN_PERMISSIONS_FETCH),
    mergeMap((action) =>
      epicServerRequest('get', `${APP.api_url}/permissions/${action.payload}`, action).pipe(
        map(epicResponseHandler(permissionsFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(TRN_PERMISSIONS_FETCH, TRN_PERMISSIONS_FETCH_CANCELED))),
        catchError(epicErrorHandler(permissionsFetchError, action)),
      ),
    ),
  )
